import { Cap, Demo, DsSection } from '../primitives'

export function TypeSection() {
  return (
    <DsSection id="type" title="Fonts & type scale" marketing>
      <Demo label="Typefaces">
        <div className="grid gap-5">
          <div>
            <Cap>Plus Jakarta Sans — headings, body, buttons</Cap>
            <div className="text-ink mt-1.5 font-sans text-[34px] font-extrabold tracking-tight">
              Insurance that works for your business
            </div>
          </div>
          <div>
            <Cap>JetBrains Mono — eyebrows, labels, meta, fine print</Cap>
            <div className="text-ink mt-1.5 font-mono text-xl font-medium">DOT 4159108 · 12 trucks</div>
          </div>
        </div>
      </Demo>
      <Demo label="Heading scale — weight 800→700, tracking tightens with size">
        <div className="text-ink grid gap-3.5">
          <div className="h1-hero">H1 Hero</div>
          <div className="h2">H2 Section</div>
          <div className="h3">H3</div>
          <div className="text-2xl font-bold tracking-[-0.01em]">H4 Card title</div>
        </div>
      </Demo>
      <Demo label="Eyebrow & meta — mono systems voice">
        <div className="grid gap-4">
          <span className="eyebrow self-start">Compliance, automated</span>
          <div className="bg-ink-900 self-start rounded-sm px-4 py-3">
            <span className="eyebrow-on-dark">Eyebrow on dark</span>
          </div>
          <div className="text-ink-500 font-mono text-xs">Last sync 2 min ago · us-east-1 · build 4.18.2</div>
          <div className="text-ink-400 font-mono text-[10px]">
            Descriptions are general in nature only. Refer to the terms and conditions of any policies
            offered.
          </div>
        </div>
      </Demo>
      <Demo label="Body & lead — lead clamps 16→20px/1.6, body 16px/1.55">
        <div className="grid max-w-xl gap-3.5">
          <p className="text-ink text-xl leading-relaxed">
            Lead — the one large paragraph under a hero, set regular weight for an open, confident read.
          </p>
          <p className="text-md text-ink-500 leading-relaxed">
            Body copy carries the detail. Sixteen pixels, generous leading, warm-neutral color so long
            passages stay comfortable without shouting.
          </p>
        </div>
      </Demo>
      <Demo label="Weight vocabulary — 400–600 utility · 700 H4/buttons · 800 attention">
        <div className="flex items-baseline gap-6">
          {[
            { number: '400', weight: 'font-normal', label: 'reg' },
            { number: '500', weight: 'font-medium', label: 'med' },
            { number: '600', weight: 'font-semibold', label: 'semi' },
            { number: '700', weight: 'font-bold', label: 'bold' },
            { number: '800', weight: 'font-extrabold', label: 'xbold' },
          ].map(({ number, weight, label }) => (
            <div key={label}>
              <div className={`text-ink font-sans text-3xl tracking-[-0.01em] ${weight}`}>{number}</div>
              <Cap className="mt-2">{label}</Cap>
            </div>
          ))}
        </div>
      </Demo>
    </DsSection>
  )
}
